import firebase from "../../config/firebase";

export const getTotalEarningsBySection = (data) => (dispatch) => {
  firebase
    .firestore()
    .collection("wallet_logs")
    .where("userId", "==", data.id)
    .where("serviceType", "==", data.serviceType)
    .orderBy("createdAt", "desc")
    .get()
    .then(async (query) => {
      let totalEarnings = 0;
      for await (let doc of query.docs) {
        totalEarnings += doc.data().amount;
      }
      dispatch({
        type: "TOTAL_EARINGS_BY_SECTIONS",
        payload: { totalEarnings: totalEarnings.toFixed(2), key: data.key }
      });
    });
};
export const getSportBadgeEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("license_purchases")
      .where("athlete_id", "==", id)
      .orderBy("created_at", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().athlete_payout
              ? doc.data().athlete_payout.payout_amount
              : 0,
            ...doc.data()
          });
        }
        dispatch({
          type: lastDocument ? "SPORT_BADGE_LOAD_MORE" : "SPORT_BADGE",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };
export const getSeasonalBadgeEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let athleteId = await firebase
      .firestore()
      .collection("users")
      .doc(id)
      .orderBy("createdAt", "desc")
      .get();
    let querya = await firebase
      .firestore()
      .collection("license_seasonal_badges")
      .where("athlete_id", "==", athleteId.data().athleteID)
      .orderBy("createdAt", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().athlete_payout
              ? doc.data().athlete_payout.payout_amount
              : 0,
            created_at: doc.data().createdAt,
            ...doc.data()
          });
        }
        dispatch({
          type: lastDocument ? "SEASONAL_BADGE_LOAD_MORE" : "SEASONAL_BADGE",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };
export const getEndorsementBadgeEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("license_endorsement_purchases")
      .where("athleteId", "==", id)
      .orderBy("createdAt", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fanId)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().athlete_payout
              ? doc.data().athlete_payout.payout_amount
              : 0,
            created_at: doc.data().createdAt,
            ...doc.data()
          });
        }
        dispatch({
          type: lastDocument
            ? "ENDORSEMENT_BADGE_LOAD_MORE"
            : "ENDORSEMENT_BADGE",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };
export const getTalkingBadgeEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("license_talking_purchases")
      .where("athlete_id", "==", id)
      .where("type", "==", "talking-badge")
      .orderBy("created_at", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().athlete_payout
              ? doc.data().athlete_payout.payout_amount
              : 0,
            created_at: doc.data().createdAt,
            ...doc.data()
          });
        }

        dispatch({
          type: lastDocument ? "TALKING_BADGE_LOAD_MORE" : "TALKING_BADGE",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };
export const getHonorBadgeEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("license_talking_purchases")
      .where("athleteId", "==", id)
      .where("type", "==", "honor-badge")
      .orderBy("created_at", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fanId)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().athlete_payout
              ? doc.data().athlete_payout.payout_amount
              : 0,
            created_at: doc.data().createdAt,
            ...doc.data()
          });
        }
        dispatch({
          type: lastDocument ? "HONOR_BADGE_LOAD_MORE" : "HONOR_BADGE",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };
export const getVoteGetterBadgeEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("license_talking_purchases")
      .where("athleteId", "==", id)
      .where("type", "==", "vote-getter")
      .orderBy("created_at", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fanId)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().athlete_payout
              ? doc.data().athlete_payout.payout_amount
              : 0,
            created_at: doc.data().createdAt,
            ...doc.data()
          });
        }
        dispatch({
          type: lastDocument
            ? "VOTE_GETTER_BADGE_LOAD_MORE"
            : "VOTE_GETTER_BADGE",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };

export const getMomentoEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("momento_purchases")
      .where("athlete_id", "==", id)
      .orderBy("createdAt", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().athlete_payout
              ? Number(doc.data().athlete_payout.payout_amount)
              : 0,
            created_at: doc.data().createdAt,
            ...doc.data()
          });
        }
        dispatch({
          type: lastDocument ? "MOMENTO_LOAD_MORE" : "MOMENTO",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };

export const getChatEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("new_a4b_chat")
      .where("athleteID", "==", id)
      .where("athlete_payment", "==", true)
      .where("type", "==", "single")
      .orderBy("created_at", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for (let doc of query.docs) {
          let fanName = await firebase
            .firestore()
            .collection("users")
            .where("email", "==", doc.data().fan_email)
            .get();
          temp_data.push({
            fanName: fanName.docs[0]?.data().name,
            Amount: doc.data()?.athlete_payout?.payout_amount,
            created_at: doc.data().athlete_payout?.payout_date
          });
        }
        dispatch({
          type: lastDocument ? "SINGLE_CHAT_MORE" : "SINGLE_CHAT",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };

export const getGroupChatEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("new_a4b_chat")
      .where("athleteID", "==", id)
      .where("athlete_payment", "==", true)
      .where("type", "==", "group")
      .orderBy("created_at", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        let fanNamePromises = [];
        for await (let doc of query.docs) {
          doc.data()?.fan_email.forEach((items) => {
            let fanNamePromise = firebase
              .firestore()
              .collection("users")
              .where("email", "==", items)
              .get()
              .then((fanName) => {
                temp_data.push({
                  fanName: fanName.docs[0]?.data().name,
                  Amount:
                    doc.data()?.athlete_payout?.payout_amount /
                    doc.data()?.fan_email.length,
                  created_at: doc.data().athlete_payout?.payout_date
                });
              });
            fanNamePromises.push(fanNamePromise);
          });
        }
        await Promise.all(fanNamePromises);
        dispatch({
          type: lastDocument ? "GROUP_CHAT_MORE" : "GROUP_CHAT",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };

export const getAthleteTalentContestEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = await firebase
      .firestore()
      .collection("contest")
      .where("leaderBoard.athleteId", "==", id)
      .orderBy("createdAt", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          temp_data.push({
            ...doc.data(),
            Amount: doc.data().winnerAmount,
            created_at: doc.data().createdAt,
            fanName: "Admin"
          });
        }
        dispatch({
          type: lastDocument ? "CONTEST_MORE" : "CONTEST_EARNINGS",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 10
          }
        });
        onComplete();
      });
  };

export const getPizzaMoneyAthleteEarnings =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = firebase
      .firestore()
      .collection("pizza-money-athletes")
      .where("athleteId", "==", id)
      .where("status", "==", "completed")
      .orderBy("createdAt", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(5)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          let totalNoFee = doc.data().totalNoFee;
          let adminAmount = totalNoFee * 0.06;
          let remainingAmount = totalNoFee - adminAmount;
          let athleteAmount = 0;
          let gwAmount = 0;
          if (remainingAmount > 100) {
            athleteAmount = 100;
            gwAmount = remainingAmount - 100;
          } else {
            athleteAmount = remainingAmount;
            gwAmount = 0;
          }
          temp_data.push({
            id: doc.id,
            ...doc.data(),
            amount: totalNoFee,
            adminAmount,
            athleteAmount,
            gwAmount
          });
        }
        dispatch({
          type: lastDocument
            ? "MORE_ATHLETE_PIZZA_MONEY_EARNINGS"
            : "ATHLETE_PIZZA_MONEY_EARNINGS",
          payload: {
            data: temp_data,
            lastDocument: query.docs[temp_data.length - 1],
            hasMoreDocument: temp_data.length >= 5
          }
        });
        onComplete();
      });
  };
